export { default as ThreeDStockProductsFiltersProductFilterBadge } from './ThreeDStockProductsFiltersProductFilterBadge';
